function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const MAX_LEFT_ITEMS = 4;
    const HEADER_CLASS_LOADED = 'is-dropdown-loaded';

    const head = document.querySelector('.gh-navigation');
    const menu = head?.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    const overflowContainer = head?.querySelector('.gh-navigation-overflow');

    if (!nav || !overflowContainer) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    function moveOverflowToActions() {
        if (mediaQuery.matches) return;

        overflowContainer.innerHTML = '';
        const items = Array.from(nav.querySelectorAll(':scope > li'));
        const total = items.length;

        if (total <= MAX_LEFT_ITEMS) {
            head.classList.add(HEADER_CLASS_LOADED);
            return;
        }

        const leftItems = items.slice(0, MAX_LEFT_ITEMS);
        const rightItems = items.slice(MAX_LEFT_ITEMS);

        rightItems.forEach(function (li) {
            nav.removeChild(li);
            overflowContainer.appendChild(li);
        });

        const lastRight = overflowContainer.querySelector('li:last-child');
        if (lastRight) {
            const link = lastRight.querySelector('a');
            if (link) {
                link.classList.add('nav-btn-meat-brown', 'gh-nav-get-started');
            }
        }

        head.classList.add(HEADER_CLASS_LOADED);
    }

    function run() {
        moveOverflowToActions();
    }

    if (typeof imagesLoaded !== 'undefined' && logo) {
        imagesLoaded(logo, run);
    } else {
        run();
    }

    window.addEventListener('load', function () {
        if (!logo) {
            run();
        }
    });

    window.addEventListener('resize', function () {
        nav.innerHTML = navHTML;
        overflowContainer.innerHTML = '';
        setTimeout(run, 1);
    });
}
